var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path4, _circle, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 285,
    viewBox: "0 0 227 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.574 47.12V284.37H190.324H194.164H226.874V251.65V47.12H57.574Z",
    fill: "#080E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0139 39.56V276.81H182.764H186.604H219.314V244.09V39.56H50.0139Z",
    fill: "#6CCA36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.454 32V269.25H175.204H179.044H211.754V236.53V32H42.454Z",
    fill: "#E8FFDF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.0002,
    y: 90,
    width: 52,
    height: 1,
    fill: "#080E04"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 126.003,
    y: 88,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 165.003,
    y: 88,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.0029,
    y: 123,
    width: 52,
    height: 1,
    fill: "#080E04"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 126.003,
    y: 123,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 165.003,
    y: 123,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.0029,
    y: 158,
    width: 52,
    height: 1,
    fill: "#080E04"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 126.003,
    y: 158,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 165.003,
    y: 158,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0029,
    y: 193,
    width: 52,
    height: 1,
    fill: "#080E04"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 130.003,
    y: 193,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 169.003,
    y: 193,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0029,
    y: 228,
    width: 52,
    height: 1,
    fill: "#080E04"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 130.003,
    y: 228,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 169.003,
    y: 228,
    width: 31,
    height: 1,
    fill: "#080E04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2217 34.8881C26.3444 42.2463 28.8986 49.563 33.853 55.5229L30.5543 58.9334C29.1444 58.2985 27.6057 57.9659 26.0141 57.9924C23.1681 58.0399 20.5115 59.1918 18.5331 61.2389L5.3221 74.8972C3.28011 77.0085 2.28806 79.7531 2.33357 82.4814C2.37909 85.2105 3.46205 87.9206 5.57338 89.9625C9.79593 94.0456 16.5537 93.9329 20.6386 89.7112L33.8488 76.052C37.0499 72.745 37.6618 67.8806 35.7487 63.9641L39.0499 60.5509C44.9972 65.1806 52.2856 67.6324 59.928 67.5049C68.7895 67.3571 77.0603 63.7678 83.2217 57.3965C95.9401 44.2493 95.5865 23.2046 82.4393 10.4871C76.0697 4.32643 67.6827 1.01329 58.8215 1.16108C49.9617 1.30886 41.6892 4.89815 35.5278 11.2695C29.1704 17.8461 26.0793 26.3941 26.221 34.8892L26.2217 34.8881ZM28.651 71.0227L15.4408 84.681C14.1288 86.0367 11.9598 86.0729 10.6031 84.7617L10.6031 84.7609C9.29098 83.4902 9.25341 81.2378 10.5224 79.9231L23.7334 66.2657C24.3683 65.6092 25.2225 65.2392 26.1355 65.224C27.0477 65.2088 27.912 65.5501 28.5686 66.1842L28.5694 66.185L28.5703 66.1858C29.2464 66.8423 29.5948 67.712 29.6094 68.5871C29.6257 69.4631 29.3065 70.3456 28.6509 71.0225L28.651 71.0227ZM77.4126 15.6872C82.5532 20.6591 85.1929 27.2604 85.3037 33.9033C85.4145 40.5461 82.9963 47.2301 78.0245 52.3723C73.208 57.3522 66.7382 60.1605 59.8104 60.2761C52.8826 60.3916 46.3236 57.8015 41.3429 52.9842L41.342 52.9833C31.0625 43.0411 30.7857 26.5862 40.731 16.2995C45.5475 11.3196 52.0173 8.51129 58.9451 8.39573C65.8729 8.27934 72.431 10.8695 77.4126 15.6868L77.4126 15.6872Z",
    fill: "#080E04"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.7424,
    cy: 34.2506,
    r: 31.634,
    fill: "#6CCA36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6977 53.6455C58.6989 53.6622 57.9036 54.4853 57.9203 55.4833C57.9369 56.4812 58.7592 57.2774 59.758 57.2607C65.882 57.1586 71.5987 54.6774 75.8571 50.2745C76.5516 49.5565 76.5325 48.4122 75.8145 47.7178C75.0965 47.0233 73.9514 47.0424 73.2578 47.7604C69.6716 51.4692 64.8564 53.5594 59.6977 53.6455L59.6977 53.6455Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.0d2fde7afe4d10517442b5d8f4f6e13b.svg";
export { ForwardRef as ReactComponent };